import registerComment from '../../../common/comments/index';
import presentationalComponent from './CommentThread';
import containerComponent from './CommentThreadContainer';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';
import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbarV2/config/toolbarToolConfig';

export default () =>
    registerComment({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.RICH_TEXT, TOOLS.COLOR, TOOLS.COLLAPSE],
        selectedTools: [TOOLBAR_TOOLS.COLOR, TOOLBAR_TOOLS.COLLAPSE, ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT],
        editingTools: [...TOOL_SETS.TEXT_EDITING_INLINE],
    });
